/**
 * External dependencies
 */
import React from 'react';
import { connect } from 'react-redux';
import page from 'page';

/**
 * Internal dependencies
 */
import Main from 'components/main';
import DocumentHead from 'data/document-head';
import Topbar from 'modules/me/topbar';
import SelectUniversalImporterPlan from 'modules/me/select-universal-importer-plan';
import { Stack, Text, Heading, Box } from '@towersystems/towersystems-design-system';
import AnnotatedSection from 'components/annotated-section';
import Notice from 'components/notice';
import { getBusinessName } from 'state/current-user/selectors';
import { getIndustryGroup } from 'state/current-user/selectors';
import { getCurrentRental } from 'state/current-rental/selectors';

/**
 * Style dependencies
 */
import './styles.scss';


const NewPlan = ({ businessName, industryGroup }) => {
    const onSuccessPlanSelect = () => {
        page.redirect('/dashboard/universal-importer');
    };

    return (
        <Box>
            <DocumentHead title='Billing - Tower Systems' />
            <Topbar title='Universal Importer' subTitle={'Hello ' + businessName} selected='universal-importer' />
            <Box marginBottom='xxlarge'>
                <Text className="plan__content">
                Universal Importer provides a API-driven solution for retailers to seamlessly integrate 
                and import external data directly into their Retailer database. Facilitating efficient 
                data exchange, the importer streamlines the process of maintaining accurate and up-to-date 
                Sales & product information, thereby enhancing operational efficiency and data consistency.
                </Text>
            </Box>
            <Main padding='xxlarge'>
                <Stack space='xxlarge'>
                    <Box>
                        <Heading level='3'>Select a Universal Importer plan</Heading>
                        <Text>
                            *Prices are excluding any applicable discounts. Please click on a plan below to subscribe.
                        </Text>
                    </Box>
                    <Box>
                        <SelectUniversalImporterPlan afterSuccess={onSuccessPlanSelect} />
                    </Box>
                </Stack>
            </Main>
        </Box>
    );
};

export default connect((state) => ({businessName: getBusinessName(state),industryGroup: getIndustryGroup(state),}), {})(NewPlan);
